import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { IApplicationWithUpdate } from '../types/Application'
import {
	mapAppRightsNullToNoPermission
} from '../../../../shared/lib/mappers/mapRightsNullToNoPermission'

export const fetchApp = createAsyncThunk<
	IApplicationWithUpdate,
	string,
	ThunkConfig<string>
>('application/fetchApp', async (appId, thunkAPI) => {

	const { extra: { api }, rejectWithValue } = thunkAPI

	try {
		const { data } = await api.get<IApplicationWithUpdate>(`/applications/${appId}`)

		// @ts-ignore
		data.rights = mapAppRightsNullToNoPermission(data.rights)

		return data as IApplicationWithUpdate
	} catch (e) {
		console.log(e)
		appHandleError(e, 'fetchApp', 'Failed to fetch application data')
		return rejectWithValue('Error occurred on fetching application data')
	}
})